<div class="d-flex align-items-end actionsheet-container" *ngIf="isOpen">

    <div class="actionsheet-body px-4 pt-4 pb-2">
        <div class="d-flex justify-content-end "
            style="color: #ff0000;font-size: 14px;font-weight: 700;margin-top: -10px; margin-right: -10px;">
            <span class="material-icons-outlined" (click)="isOpen=!isOpen">
                close
            </span>
        </div>
        <div class="d-flex justify-content-center" style="color: #0057FF;font-size: 25px;font-weight: 700;">
            Add Transaction
        </div>
        <ng-container *ngIf="true">
            <div class="d-flex justify-content-center py-2 flex-column" style="color: #9C9C9C;font-size: 16px;font-weight: 700;">
                <input
                    style="border-radius: 10px;border: 0px;background-color: #E9F1F5;width: 100%;height: 40px;padding-left: 15px;"
                    type="number" placeholder="Enter Amount" [(ngModel)]="Amount" autocomplete="off">
                <!-- <input
                    style="border-radius: 10px;border: 0px;background-color: #E9F1F5;width: 100%;height: 40px;padding-left: 15px; margin-top: 8px;"
                    type="text" placeholder="Narration" [(ngModel)]="otp" autocomplete="off"> -->
            </div>
            <div class="d-flex justify-content-center py-2">
                <button type="submit" class="btn btn-primary d-flex align-items-center justify-content-center"
                    (click)="submitTran()" [disabled]="isLoading"
                    style="width: 100%;border-radius: 15px;background-color: #0057FF;box-shadow:rgb(0 0 0 / 15%) 0px 1px 4px 1px, rgb(0 0 0 / 12%) 0px 2px 2px 0px, rgb(0 0 0 / 10%) 0px 1px 5px 0px;border-radius: 20px; height: 45px;">
                    <span style="font-size: 18pxx;font-weight: 500;" class="mr-2">{{isLoading ? 'Adding...' : 'Add'}}</span>
                    <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status"
                        aria-hidden="true"></span>
                </button>
            </div>
        </ng-container>

    </div>
</div>